import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles((theme)=>({
    container:{
        marginTop:'25px',
        marginBottom:'25px',
        backgroundColor:theme.palette.background.paper,
        padding:'10px',
        borderRadius:'10px'
    },
    icon: {
        marginRight: "20px",
      },
      buttons: {
        marginTop: "40px",
      },
    
      cardGrid: {
        padding: "20px 0",
      },
      card: {
        height: "100%",
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        borderRadius: '15px',    position: 'relative',
        '&:hover':{
            transform: 'translateY(-10px)',
            boxShadow: '1em 1em 1em -0.4em black'
          },
        transition:'all 0.3s'
    
      },
      footer:{
          backgroundColor:theme.palette.background.paper,
          paddingTop:'50px 0'
      },
      cardMedia: {
        height: 0,
        paddingTop: "56.25%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        backgroundBlendMode: "lighten",
      },
    //   cardMedia: {
    //     height: "700px",
    //     paddingTop: "56.25%",
    //   },
      cardContent: {
        flexGrow: 1,
      },
      main:{
        padding:'20px',
    },
    overlay2: {
      position: 'absolute',
      top: '10px',
      right: '15px',
      color: 'white',
    },
}));
export default useStyles;